import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import RouteTile from "./RouteTile";

const styles = {
  root: {
    display: "flex",
    flexDirection: "column"
  }
};

class RoutesOverview extends Component {
  state = {};
  render() {
    const { classes, routes, onSelectRoute } = this.props;

    const tiles = routes.map(route => {
      return (
        <RouteTile
          key={route.routeKey}
          onSelectRoute={onSelectRoute}
          {...route}
        />
      );
    });

    return <div className={classes.root}>{tiles}</div>;
  }
}

RoutesOverview.propTypes = {
  classes: PropTypes.object.isRequired,
  routes: PropTypes.array.isRequired,
  onSelectRoute: PropTypes.func.isRequired
};

export default withStyles(styles)(RoutesOverview);



// WEBPACK FOOTER //
// ./src/Ambassadors/atoms/RoutesOverview.js